// Support: TextField

import React, { FC } from 'react';
import { getIn } from 'formik';

export const withFormik = (Component: FC<any>) => (props: any) => {
	const { field, form, ...rest } = props;
	const touched = getIn(form.touched, field.name);
	const error = getIn(form.errors, field.name);
	return (
		<Component
			{...field}
			{...rest}
			form={form}
			error={!!touched && !!error}
			helperText={error && touched ? error : undefined}
		/>
	);
};

export default withFormik;
